import ErrorPage from 'components/global/error-page'
import { Navigate } from 'react-router-dom'

import { buildRoute, Route } from './build-route'
import { paths } from './paths'

export const authRoutes: Array<Route> = [
  buildRoute({
    path: '/',
    factory: () => import('pages/general-toolbar-layout'),
    children: [
      buildRoute({
        path: paths.projects,
        factory: () => import('pages/projects'),
        title: 'projects.list.projects',
      }),
      buildRoute({
        path: paths.profileSettings,
        factory: () => import('pages/profile-settings'),
        title: 'user_profile.profile_settings',
      }),
      buildRoute({
        path: paths.settings,
        factory: () => import('pages/settings'),
        title: 'common.settings',
      }),
      buildRoute({
        path: paths.plans,
        factory: () => import('pages/plans'),
      }),
      buildRoute({
        path: paths.payments,
        factory: () => import('pages/payments'),
      }),
      buildRoute({
        path: paths.planPurchase,
        factory: () => import('pages/plans/purchase'),
      }),
    ],
  }),
  buildRoute({
    path: paths.gitlabIntegration,
    factory: () => import('pages/projects/gitlab-integration'),
  }),
  buildRoute({
    path: paths.projectDetails,
    factory: () => import('pages/projects/details'),
    children: [
      buildRoute({
        path: paths.projectOverview,
        factory: () => import('pages/projects/details/project-overview'),
      }),
      buildRoute({
        path: paths.projectTerms,
        factory: () => import('pages/projects/details/project-terms'),
      }),
      buildRoute({
        path: paths.projectUsers,
        factory: () => import('pages/projects/details/project-users'),
      }),
      buildRoute({
        path: paths.projectSettings,
        factory: () => import('pages/projects/details/project-settings'),
      }),
      buildRoute({
        path: paths.projectHistory,
        factory: () => import('pages/projects/details/project-history'),
      }),
      {
        index: true,
        element: <Navigate to="overview" />,
      },
    ],
  }),
  buildRoute({
    path: paths.signUpConfirmation,
    factory: () => import('pages/projects'),
  }),
  buildRoute({
    path: paths.emailChangeConfirmation,
    factory: () => import('pages/email-change-confirmation'),
  }),
  buildRoute({
    path: paths.figmaIntegrationRedirect,
    factory: () => import('pages/figma-integration-redirect'),
  }),

  {
    index: true,
    element: <Navigate to={paths.projects} />,
  },
  {
    path: paths.signIn,
    element: <Navigate to={paths.projects} replace />,
  },
  {
    path: '*',
    element: <ErrorPage variant="NOT_FOUND" />,
  },
]
